/**
 * @license Givaudan
 * @author Ayoub MHAMDI
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BgFallbackDirective } from '@banyan/commons/directives/bg-img-fallback.directive';
import { ImgFallbackDirective } from '@banyan/commons/directives/src-fallback.directive';
import { DefaultCurrencyPipe } from '@banyan/commons/pipes/default-currency.pipe';
import {
  BannerWithActionComponent,
} from '@banyan/modules/builder-io/components/common/banner-with-action/banner-with-action.component';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';
import { IconComponent } from '@banyan/modules/standalone/icon/icon.component';
import { Content } from '@builder.io/sdk-angular';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './components/header/header.component';
import { HeaderNavbarComponent } from './components/header-navbar/header-navbar.component';
import { HeaderSidenavComponent } from './components/header-sidenav/header-sidenav.component';
import { HeaderRoutingModule } from './header.routing.module';

@NgModule({
  imports: [
    Content,
    CommonModule,
    HeaderRoutingModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    SharedModule,
    TranslateModule,
    ButtonComponent,
    MatSelectModule,
    ReactiveFormsModule,
    MatSidenavModule,
    BrowserAnimationsModule,
    MatListModule,
    MatExpansionModule,
    BgFallbackDirective,
    ImgFallbackDirective,
    DefaultCurrencyPipe,
    IconComponent,
    BannerWithActionComponent,
  ],
  declarations: [
    HeaderComponent,
    HeaderNavbarComponent,
    HeaderSidenavComponent,
  ],
  exports: [HeaderComponent, MatSidenavModule, HeaderSidenavComponent],
})
export class HeaderModule {
}
